const cookingMethod = {
    name_en: '',
    name_de: '',
};

export const formInitialValues = {
    cookingMethod,
};
